import { apiClient as api, setAuthorization } from "./api_helper";
import * as url from "./url_helper";

// Get logged in user from localStorage
export const getLoggedInUser = () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
};

// Check if user is authenticated
export const isUserAuthenticated = () => getLoggedInUser() !== null;

// // Register Method
// export const postRegister = (data: any) => api.post(url.POST_REGISTER, data);

// Login Method
export const postLogin = (data: any) => api.post(url.LOGIN, data);

// // Forgot Password
// export const postForgetPassword = (data: any) => api.post(url.POST_FORGOT_PASSWORD, data);

// Edit Profile
export const postEditProfile = (data: any) => api.put(`${url.POST_EDIT_PROFILE}/${data.idx}`, data);

// JWT Register Method
export const postJwtRegister = async (endpoint: string, data: any) => {
    try {
        return await api.post(endpoint, data);
    } catch (err: any) {
        handleApiError(err);
    }
};

// JWT Login
export const postJwtLogin = (data: any) => api.post(url.LOGIN, data);

// // JWT Forgot Password
// export const postJwtForgetPwd = (data: any) => api.post(url.POST_JWT_FORGOT_PASSWORD, data);

// Social Login
// export const postSocialLogin = (data: any) => api.post(url.SOCIAL_LOGIN, data);

// Error handler function
const handleApiError = (error: any) => {
    const status = error.response?.status;
    let message = "An error occurred";

    if (status === 404) message = "Page not found";
    else if (status === 500) message = "Server error, please contact support";
    else if (status === 401) message = "Invalid credentials";
    else if (error.message) message = error.message;

    throw message;
};
